import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { eventBus } from './eventBus.js';

let _es = null;

export function useSSE() {
  const qc = useQueryClient();
  useEffect(() => {
    const token = localStorage.getItem('utsc_token');
    if (!token) return;
    if (_es) return; // singleton across re-mounts
    const url = `/api/notifications/stream?token=${encodeURIComponent(token)}`;
    const es = new EventSource(url);
    _es = es;

    const dispatch = (kind, payload) => {
      eventBus.emit('notification', { kind, ...payload });
      // Invalidate relevant queries so badges/lists refresh
      if (kind === 'ai_question') qc.invalidateQueries({ queryKey: ['ai-questions'] });
      if (kind === 'followup_due') qc.invalidateQueries({ queryKey: ['followups'] });
      if (kind === 'recap_ready') qc.invalidateQueries({ queryKey: ['recaps'] });
    };

    es.addEventListener('ai_question', e => {
      try { dispatch('ai_question', JSON.parse(e.data)); } catch {}
    });
    es.addEventListener('followup_due', e => {
      try { dispatch('followup_due', JSON.parse(e.data)); } catch {}
    });
    es.addEventListener('recap_ready', e => {
      try { dispatch('recap_ready', JSON.parse(e.data)); } catch {}
    });
    es.addEventListener('hello', () => {});
    es.onerror = () => {
      // EventSource auto-retries — leave it.
    };

    return () => {
      es.close();
      _es = null;
    };
  }, [qc]);
}
